<template>
    <div class="fotos">
        <div class="registry-wrapper">
            <div class="columns is-multiline">
                <div
                    class="column is-full photo-warning py-1"
                    v-if="
                        minimoFotos > fotos.length &&
                        situacao == 0 &&
                        ((!isUpdate && permissao.create) || (isUpdate && permissao.update))
                    "
                >
                    {{ $t('msg-n-fotos-atendimento', { n: minimoFotos }) }}
                </div>
                <div
                    class="column is-full is-flex"
                    v-if="
                        situacao == 0 &&
                        ((!isUpdate && permissao.create) || (isUpdate && permissao.update))
                    "
                >
                    <file-picker
                        ref="filePicker"
                        class="upload-picker is-100"
                        v-model="file"
                        accepted="image/*"
                        :allowedtypes="['image/jpeg', 'image/png']"
                        :disabled="isUploading || isLoading"
                        @alert="showMessage"
                        return-raw-file
                    />
                    <button
                        class="btn save-btn ml-4 px-4 py-2 is-flex is-flex-centered"
                        @click="addAnexo"
                        :disabled="isUploading || !file || isLoading"
                    >
                        {{ $t('adicionar') }}
                        <button-loader :isSaving="isUploading" />
                    </button>
                </div>
                <div class="column obs is-flex" v-if="situacao == 0">
                    <v-textarea
                        v-model.trim="obsFoto"
                        :title="$t('observacao')"
                        :maxlength="255"
                        :disabled="isUploading || isLoading"
                        disableMLtitle
                    />
                </div>
            </div>
            <container-loader class="fotos-loader" v-if="isLoading && !$store.getters.isLoading" />
            <empty-table-message v-if="fotos && !fotos.length" />
            <b-table
                v-else
                ref="fotosTable"
                class="data-table"
                :data="fotos"
                @sort="sortFotos"
                backend-sorting
            >
                <b-table-column
                    v-for="(f, i) in fieldsFoto"
                    class="td-center"
                    :key="i"
                    :field="f.key"
                    :label="f.key != 'excluir' ? $t(f.label) : ''"
                    :width="f.width"
                    :sortable="f.sortable"
                    :centered="f.centered"
                    v-slot="props"
                >
                    <div v-if="f.key == 'excluir' && situacao === 0" class="no-strike">
                        <b-field :addons="false">
                            <b-button
                                v-if="permissao.delete"
                                type="is-danger"
                                icon-right="delete"
                                @click="confirmExclusion(props.row)"
                                v-tippy 
                                :title="$t('excluir')"
                            />
                        </b-field>
                    </div>
                    <div v-else-if="f.key == 'datahora'">
                        {{ props.row[f.key] | moment('L LT') }}
                    </div>
                    <div v-else-if="f.key == 'observacao'">
                        {{ props.row[f.key] }}
                    </div>
                    <div v-else-if="f.key == 'caminho'">
                        <img
                            :src="props.row[f.key]"
                            :alt="props.row['observacao']"
                            class="clickable"
                            @click="openModalFotos(props.row[f.key])"
                        />
                    </div>
                    <a
                        v-else-if="f.key == 'download'"
                        :href="props.row['caminho']"
                        target="_blank"
                        class="export-icon"
                    >
                        <b-icon
                            icon="file-download"
                            size="is-medium"
                            class="is-medium is-clickable"
                            v-tippy 
                            :title="$t('msg-tooltip-imagem-download')"
                        />
                    </a>
                </b-table-column>
            </b-table>
            <PaginationViewer
                v-if="!isEmpty"
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>

        <!-- Modal fotos do atendimento -->
        <b-modal
            class="modal-default"
            :active.sync="isShowModalFotos"
            style="z-index: 1000"
            @close="(carousels = []), (isShowModalFotos = false)"
        >
            <div class="modal-card-body">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <template>
                            <b-carousel :pause-info="false" :animated="'fade'" :progress="true">
                                <b-carousel-item v-for="(carousel, i) in carousels" :key="i">
                                    <section>
                                        <div class="hero-body-img has-text-centered">
                                            <b-image
                                                :src="carousel.url"
                                                :responsive="true"
                                                class="image-control"
                                            />
                                        </div>
                                    </section>
                                </b-carousel-item>
                            </b-carousel>
                        </template>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import AtendimentoService from '@/services/AtendimentoService';
import FilePicker from '@/components/shared/form/FilePicker';
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    props: {
        minimoFotos: {
            type: Number,
            default: 0,
        },
        situacao: {
            type: Number,
            default: 0,
        },
        uuidFrom: {
            type: String,
            defult: '',
        },
        isUpdate: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        FilePicker,
        ContainerLoader,
    },
    data() {
        return {
            service: new AtendimentoService(this.$http, this.$router),
            uuid: this.uuidFrom,
            file: null,
            obsFoto: null,
            fotos: [],
            isLoading: false,
            isEmpty: true,
            isUploading: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: 'datahorainc',
            order: 'desc',
            fieldsFoto: [
                {
                    key: 'caminho',
                    label: 'arquivo',
                    sortable: false,
                    centered: true,
                },
                {
                    key: 'observacao',
                    label: 'observacao',
                    sortable: true,
                    width: '70%',
                },
                {
                    key: 'datahora',
                    label: 'data-hora',
                    sortable: true,
                    width: 200,
                    centered: true,
                },
                {
                    key: 'download',
                    label: 'download-arquivo',
                    sortable: false,
                    width: 50,
                    centered: true,
                },
                {
                    key: 'excluir',
                    label: '',
                    sortable: false,
                },
            ],
            isShowModalFotos: false,
            carousels: [],
            permissao: false,
            promptedForRemoval: null,
            isRemoving: false,
            fromDelete: false,
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.permissao = this.hasPermissionAccess('vendas', 'crm', 'ven-atendimento');
        if (!this.isUpdate && !this.permissao.create) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'atendimentos' },
            });
        } else {
            this.carregarDados();
        }
    },
    watch: {
        file(val) {
            this.$emit('isChanged', val != null || !this.isNull(this.obsFoto));
        },
        obsFoto(val) {
            this.$emit('isChanged', this.file != null || !this.isNull(val));
        },
    },
    methods: {
        openModalFotos(caminho, observacao) {
            this.carousels = [];
            const images = this.fotos;

            // Filter out the selected photo from the array of photos
            const filteredFotos = images.filter((foto) => foto.caminho !== caminho);

            // Create a new array for the carousel, combining the selected photo and the rest of the photos
            this.carousels = [
                { url: caminho, nome: observacao },
                ...filteredFotos.map((foto) => ({ url: foto.caminho, nome: foto.observacao })),
            ];

            this.isShowModalFotos = true;
        },
        showMessage({ type, message }) {
            this.$root.showMessage(type, message);
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.service
                .listAttachments(
                    this.uuid,
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage
                )
                .then((r) => {
                    this.fotos = r.content;
                    this.pagination.totalRows = r.totalElements;
                    this.isEmpty = r.totalElements <= 0;
                })
                .catch((e) => {
                    this.fotos = [];
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-carregar-foto-atendimento');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;

                    if (this.fromDelete) {
                        this.isRemoving = false;
                        this.fromDelete = false;
                    }
                    this.$emit('lengthFotos', this.fotos.length);
                });
        },
        addAnexo() {
            this.obsFoto = this.mapTosave(this.obsFoto);
            this.obsFoto = this.obsFoto == null ? '' : this.obsFoto;

            let formbody = new FormData();
            formbody.append('file', this.file);
            formbody.append('observacao', this.obsFoto);

            this.isUploading = true;

            this.service
                .uploadAttachment(this.uuid, formbody)
                .then((r) => {
                    this.$root.showMessage('success', 'msg-anexo-salvo-sucesso');

                    if (this.$refs.fotosTable) {
                        this.$refs.fotosTable.currentSortColumn = {};
                    }

                    this.file = null;
                    this.$refs.filePicker.clearFile();
                    this.obsFoto = null;
                })
                .catch((e) => {
                    console.error('Erro ao carregar anexo.', e);
                    this.$root.showMessage('error', 'msg-erro-ven-cliente-anexo-upload');
                })
                .finally((_) => {
                    this.isUploading = false;
                    this.carregarDados();
                    console.log("🚀 ~ .finally ~ this.fotos.length:", this.fotos.length)
                });
        },
        sortFotos(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        confirmExclusion(anexo) {
            this.promptedForRemoval = anexo;

            this.$root.confirm({
                message: this.$t('msg-confirmacao-exclusao-anexo'),
                onConfirm: (_) => this.onExclusion(),
            });
        },
        onExclusion() {
            this.deleteAnexo(this.promptedForRemoval);
            this.isRemoving = this.promptedForRemoval != null;
            this.promptedForRemoval = null;
        },
        deleteAnexo(anexo) {
            this.isLoading = true;
            this.service
                .deleteAnexos(anexo)
                .then((r) => {
                    this.fromDelete = true;
                })
                .finally((_) => {
                    this.$root.showMessage('success', 'msg-anexo-deletado-sucesso');
                    this.carregarDados();
                });
        },
    },
};
</script>

<style lang="scss" scoped>
@import './mixins.scss';
.columns:last-child {
    padding-top: 0.2rem !important;
}
.is-multiline {
    padding-top: 10px;
}
.fotos {
    flex-grow: 1;
    display: flex;
    flex-direction: column;

    .fotos-loader {
        margin-top: -1rem;
    }
}
.obs {
    display: flex;
    margin-bottom: 20px;
    flex-direction: column;
    flex-grow: 1;

    .obs-ta {
        flex-grow: 1;
        min-height: 250px;
    }
}
.upload-picker {
    font-size: 12px;
}
.img-table {
    max-height: 10vh;
    max-width: 10vw;
}
.photo-warning {
    display: flex;
    justify-content: center;
    color: $red-alert;
    font-weight: bold;
}
.hero-body-img {
    padding: 20px;
}
@media only screen and (max-width: 760px) {
    .column {
        padding-bottom: 0;
    }
}
@media only screen and (min-width: 760px) {
    .column {
        @include default-size-column;
    }
}
</style>
